import React, {useEffect, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, FormGroup, Label, Row, Spinner} from 'reactstrap';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";
import Select from "react-select";
import Switch from "react-bootstrap-switch";


// actions
import { ADD_STATE, REMOVE_STATE, setForm, setItem, setLoading } from "../../../../redux/actions/generics/IndexedActions";
import { genericIndexedActions } from "../../../../redux/actions/generics/GenericIndexedActions";


// labels
import { TT_CLOSE } from "../../../../components/i18n/toolTips";
import { error } from "../../../../components/i18n/i18n";


// components
import { PromotionProductForm } from "./_form";
import Separator from "../../../../components/Separator";
import PromotionProductItem from "./productRenderContent";
import { showToastCustom } from "../../../../components/toast/customToast";
import { GenericButton } from "../../../../components/buttons/customButtons";
import { ConfirmDelete } from "../../../../components/confirmAlert/ConfirmDelete";
import { productPriceService } from "../../../../jwt/_services/promotions/productPriceService";

// service
import { productPromotionService } from "../../../../jwt/_services/promotions/productPromotionService";


const PromotionProduct = (props) => {
    const path = props.path + '/product';
    // const [parent] = useState(props.parent || null);
    const componentState = useSelector(state => getStateByPath(state, path));
    const parentState = useSelector(state => getStateByPath(state, props.path));

    const { listDomainObjects, loading } = componentState?.data || [];
    const { domainObject, app } = parentState?.data || {};

    const [filteredList, setFilteredList] = useState( []);

    const [sectionMode, setSectionMode] = useState('regular');

    const [udnOptions, setUdnOptions] = useState([]);
    const [udnOptionsSelected, setUdnOptionsSelected] = useState(null);

    const [typeProductOptions, setTypeProductOptions] = useState([]);
    const [typeProductOptionsSelected, setTypeProductOptionsSelected] = useState(null);

    const [categoryProductOptions, setCategoryProductOptions] = useState([]);
    const [categoryProductOptionsSelected, setCategoryProductOptionsSelected] = useState(null);

    const [onlyOnDatabase, setOnlyOnDatabase] = useState(true);
    const [onlyActive, setOnlyActive] = useState(null);

    const [showFormModal, setShowFormModal] = useState(true);
    const formModalRef = useRef(null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (!listDomainObjects || listDomainObjects.length === 0)
            return;

        let _filteredList = listDomainObjects.slice();

        setFilteredList( _filteredList.filter((item) => item.uid !== null) );

        let _udnOptions = [];
        // Llena el listado de udnOptions con los valores únicos de udnName y udnCode
        listDomainObjects.forEach((item) => {
            if (!_udnOptions.find((udn) => udn?.id === item?.udnCode)) {
                _udnOptions.push({
                    id: item?.udnCode,
                    value: item?.udnCode,
                    label: <label>{item?.udnCode?.toUpperCase() + ' - '} <b>{item?.udnName}</b> </label>
                })
            }
        })
        setUdnOptions(_udnOptions);

        let _typeProductOptions = [];
        // Llena el listado de typeProductOptions con los valores únicos de typeProductCode y typeProductDescription
        listDomainObjects.forEach((item) => {
            if (!_typeProductOptions.find((typeProduct) => typeProduct?.id === item?.typeProductCode)) {
                _typeProductOptions.push({
                    id: item?.typeProductCode,
                    value: item?.typeProductCode,
                    label: <label>{item?.typeProductCode?.toUpperCase() + ' - '} <b>{item?.typeProductName}</b> </label>
                })
            }
        })

        setTypeProductOptions(_typeProductOptions);

        let _categoryProductOptions = [];
        // Llena el listado de categoryProductOptions con los valores únicos de categoryProductCode y categoryProductDescription
        listDomainObjects.forEach((item) => {
            if (!_categoryProductOptions.find((categoryProduct) => categoryProduct?.id === item?.categoryProductCode)) {
                _categoryProductOptions.push({
                    id: item?.categoryProductCode,
                    value: item?.categoryProductCode,
                    label: <label>{item?.categoryProductCode?.toUpperCase() + ' - '} <b>{item?.categoryProductName}</b> </label>
                })
            }
        })

        setCategoryProductOptions(_categoryProductOptions);

    }, [listDomainObjects]);

    useEffect(() => {
        if (!app || !domainObject)
            return;

        const dataRequest = {
            fbDataBase: { id: app?.fbDataBase?.id },
            item : {
                promotion: {id: domainObject?.id},
            }
        };

        genericIndexedActions.search(path, productPromotionService, 0, 1000, dataRequest)
    }, [domainObject, app]);

    const notImplemented = () => {
        console.log('Not implemented yet');
    }

    const returnToList = () => {
        props.setItem(props.path, null);
        props.setForm(false, false, false);
        props.onClose();
    }

    const createItem = () => {
        props.setForm(path, true, false, false);
        props.setItem(path, null);

        setShowFormModal(true);
        formModalRef.current.showModal(null, listDomainObjects?.length || 0, domainObject);
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        setShowFormModal(true);
        formModalRef.current.showModal(data, listDomainObjects?.length || 0, domainObject);
    }

    const confirmDelete = (data) => {
        genericIndexedActions.delete(path, productPromotionService, data?.id, app?.fbDataBase?.id);

        // return ConfirmDelete({
        //     path,
        //     data,
        //     service: productPromotionService,
        //     fbDataBaseId : app?.fbDataBase?.id,
        //     remove : genericIndexedActions.delete
        // });
    };

    const syncPrices = (data) => {
        props.setLoading(path,true);
        const dataRequest = {
            promotion: {id: domainObject?.id},
            product: {id: data?.product?.id}
        }

        productPriceService.syncSingleProduccInPromotionPrices(dataRequest)
            .then(_ => {
                props.setLoading(path,false);
            })
            .catch(errorMessage => {
                props.setLoading(path,false);
                showToastCustom(error, errorMessage);
            });
    }

    const handleStatusChange = (id, data, status) => genericIndexedActions.update(path, productPromotionService, id, {
        fbDataBase:  { id : app?.fbDataBase?.id },
        item: { ...data, status, id  }
    })

    const renderContent = (item, index) => {
        return (
            <PromotionProductItem
                item={item}
                index={index}
                onEdit={editItem}
                onDelete={confirmDelete}
                onUpdatePrices={syncPrices}
                handleStatusChange={handleStatusChange}
                onManualUpdatePrices={notImplemented} // TODO : ---
            />
        )
    }

    const onFilterList = (option, value) => {
        let _filteredList = listDomainObjects.slice();

        let _udnOptionsSelected = udnOptionsSelected;
        let _typeProductOptionsSelected = typeProductOptionsSelected;
        let _categoryProductOptionsSelected = categoryProductOptionsSelected;
        let _onlyOnDatabase = onlyOnDatabase;
        let _onlyActive = onlyActive;

        if (option === 'onlyActive') {
            _onlyActive = value;
            setOnlyActive(value);
        }

        if (option === 'onlyRegistered') {
            _onlyOnDatabase = value;
            setOnlyOnDatabase(value);
        }

        if (option === 'udn') {
            _udnOptionsSelected = value;
            setUdnOptionsSelected(value);
        }

        if (option === 'typeProduct') {
            _typeProductOptionsSelected = value;
            setTypeProductOptionsSelected(value);
        }

        if (option === 'categoryProduct') {
            _categoryProductOptionsSelected = value;
            setCategoryProductOptionsSelected(value);
        }

        if (_onlyActive)
            _filteredList = _filteredList.filter((item) => item.status === true);

        if (_onlyOnDatabase)
            _filteredList = _filteredList.filter((item) => item.uid !== null);

        if (_udnOptionsSelected)
            _filteredList = _filteredList.filter((item) => item.udnCode === _udnOptionsSelected.id);

        if (_typeProductOptionsSelected)
            _filteredList = _filteredList.filter((item) => item.typeProductCode === _typeProductOptionsSelected.id);

        if (_categoryProductOptionsSelected)
            _filteredList = _filteredList.filter((item) => item.categoryProductCode === _categoryProductOptionsSelected.id);


        setFilteredList(_filteredList);
    }





    const syncProducts = () => {
        const requestData = {
            fbDataBase:{id: app?.fbDataBase?.id },
            item:{ id: domainObject?.id }
        }

        genericIndexedActions.sync(path, productPromotionService, requestData)
    }





    return (
        <Card className={'promotion-product-container'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <h2 className={'card-modal-title'} > {  'Productos de: ' + (domainObject?.code || '') }</h2>
                    <br />
                    <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                </>
                <div className="top-right">
                    <GenericButton
                        style={'success-secondary'}
                        label={'Agregar'}
                        toolTip={'Agregar producto'}
                        icon={ 'fa-plus' }
                        permission={'add'}
                        onClick={createItem}/>
                    <Separator/>
                    <GenericButton
                        style={'warning-secondary'}
                        label={'Sincronizar productos'}
                        toolTip={'Sincronizar producto'}
                        icon={ 'fa-sync' }
                        permission={'add'}
                        loading={false}
                        onClick={syncProducts}/>
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={returnToList}
                    />
                </div>
            </CardTitle>
            <CardBody >
                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label >Unidad de negocio</Label>
                            <br/>
                            <Select
                                value={udnOptionsSelected}
                                options={udnOptions}
                                isClearable={true}
                                onChange={value => onFilterList('udn', value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label >Tipo de producto</Label>
                            <br/>
                            <Select
                                value={typeProductOptionsSelected}
                                options={typeProductOptions}
                                isClearable={true}
                                onChange={value => onFilterList('typeProduct', value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label >Categoria del producto</Label>
                            <br/>
                            <Select
                                value={categoryProductOptionsSelected}
                                options={categoryProductOptions}
                                isClearable={true}
                                onChange={value => onFilterList('categoryProduct', value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Solo en App'}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyOnDatabase}
                                onChange={_ => onFilterList('onlyRegistered', !onlyOnDatabase)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Activos'}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyActive}
                                onChange={_ => onFilterList('onlyActive', !onlyActive)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                {
                    loading ? <Spinner animation="border"/> :
                        <div className={'promotion-product-body'}>
                            {
                                // enlistar listDomainObjects ordenandolos por udnName, luego por typeProductCode y finalmente por categoryProductCode
                                filteredList?.length !== 0 && filteredList?.sort((a, b) => {
                                    let comparison = a?.udnName?.localeCompare(b?.udnName);
                                    if (comparison !== 0) return comparison;

                                    comparison = a?.typeProductCode?.localeCompare(b?.typeProductCode);
                                    if (comparison !== 0) return comparison;

                                    return a?.categoryProductCode?.localeCompare(b?.categoryProductCode);
                                }).map((item, index) => renderContent(item, index))
                            }
                        </div>
                }
            </CardBody>
            {
                showFormModal && <PromotionProductForm
                    path={path}
                    promotion={domainObject}
                    app={app}

                    ref={formModalRef}
                />
            }
        </Card>
    );
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setForm,
    setItem,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(PromotionProduct)
